module.exports = __webpack_public_path__ + "static/media/scanopro-2.0f59bd4d.jpg";